import { render, staticRenderFns } from "./CoursesDialogWrapper.vue?vue&type=template&id=926c0e24&scoped=true&"
import script from "./CoursesDialogWrapper.vue?vue&type=script&lang=js&"
export * from "./CoursesDialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CoursesDialogWrapper.vue?vue&type=style&index=0&id=926c0e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926c0e24",
  null
  
)

export default component.exports